import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import fnsReportIcon from './../../../assets/img/mm/clipboard-solid-full.svg';
import download from 'downloadjs';
class FNSCollectionReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            userInfo: getLoginDistrictInfo(),
        }
    }

    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
      }
    getFNSReport = () => {
            const districtID = this.state.userInfo.districtId;
            const verificationYear = this.props.selectedSchoolYear;
            const schoolId = this.props.selectedSchoolId;
            this.setState({ loading: true });
            const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';       
            get(`/verification/reports/fns742/export/${districtID}/${verificationYear}?${schoolParam}format=pdf&access_token=`)
              .then((response) => {
                if (!response.ok) {
                    throw new Error('No data found');
                }
              return response.blob();
          })
        .then((blob) => {
            download(blob, `FNS-742-Collection-Report-${verificationYear}.pdf`, 'application/pdf');
            this.setState({ loading: false });
        })
        .catch((error) => {
            console.error('Error fetching FNS report:', error);
            this.setState({ loading: false });
        });     
    }
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={fnsReportIcon} style={{ width: '40px', height: '40px' }} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>FNS-742 Collection Report</b></span>
                                    <p>Federal Summary, all sections</p>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action' style={{
                                                                                    marginLeft: 'auto',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center' }}>
                                   <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={() => {
                                        this.getFNSReport();
                                    }}>
                                        <i className="fa fa-file-pdf-o" /> Pdf
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default FNSCollectionReport;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/fNSCollectionReport.js